<template>
  <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" @keyup.esc="closePopup">
    <div class="bg-white p-6 rounded-lg shadow-lg max-w-xl w-full dark:bg-dark-modal">
      <button @click="closePopup" class="absolute top-2 right-2 text-gray-600 hover:text-gray-900">&times;</button>
      <h2 class="text-xl font-semibold mb-4 dark:text-dark-text">Enter Story Details</h2>
      <form @submit.prevent="handleSave">
        <div class="mb-4">
          <label for="storyText" class="block text-sm font-medium text-gray-700 dark:text-dark-text">Story Title:</label>
          <textarea id="storyText" v-model="storyText" rows="4"
                    placeholder="Put your stories text here. Each line contains new story."
                    class="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm resize-none"
                    required>
          </textarea>
          <div class="mt-2 text-xs text-gray-500 flex items-center justify-end gap-1">
            <span>
              Use new lines to create multiple stores
            </span>
            <span class="border border-gray-400 rounded px-1">↵</span>
          </div>
        </div>
        <div class="grid grid-cols-2 grid-rows-2 gap-2">
          <Button variant="primary" @click.prevent="saveAndClose" title="Save and Close" :disabled="!isValid" :loading="isSaving" />
          <Button variant="primary" @click.prevent="saveAndNew" title="Save and New" :disabled="!isValid" :loading="isSaving" />
          <Button variant="primary" @click.prevent="$emit('openImportStories')" title="Import"/>
          <Button variant="outline" @click.prevent="closePopup" title="Cancel"/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import FBApp from "@/library/firebase";
import RoomStore from '@/store/room';
import {toast} from "vue3-toastify";

const {logEvents} = FBApp;
export default {
  components: {Button},
  emits: ['fetchStories', 'openImportStories'],
  data() {
    return {
      roomId: this.$route.params.id,
      isVisible: false,
      storyText: '',
      isSaving: false,
    };
  },

  computed: {
    stories() {
      return this.storyText.split('\n')
          .filter(text => !!text.trim())
          .map(text => text.substring(0, 99));
    },
    isValid(){
      return this.storyText?.length >= 2;
    }
  },

  methods: {
    closePopup() {
      RoomStore.toggleStoryForm(false);
    },

    async handleSave(hasClose) {
      this.isSaving = true;
      return RoomStore.storeStories([...this.stories])
          .then(data => {
            toast.success(data?.message || 'Saved successfully');
            this.$emit('fetchStories');
            if (hasClose) {
              this.closePopup();
              return;
            }
            logEvents('Success Saved Stories')
            this.storyText = '';
          })
          .catch(error => {
            logEvents('Error Saved Stories')
            toast.error(error?.message || 'Something went wrong!')
          }).finally(()=>{
            this.$nextTick(()=>{
              this.isSaving = false;
            })
          })
    },

    saveAndClose() {
      return this.handleSave(true);
    },

    saveAndNew() {
      return this.handleSave();
    }
  }
};
</script>
